import React from 'react';

const CanvasContext = React.createContext(null);

export default CanvasContext;
